import {useInfiniteQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getUserRetractPointHistory} from '../../../apis/point/getUserRetractPointHistory'

const PAGE_SIZE = 30

const useQueryPointRetractList = () => {
    const {data, refetch, isLoading, isFetchingNextPage, fetchNextPage} = useInfiniteQuery({
        queryKey: QueryCacheKeys.point.getRetractPointHistory(),
        refetchInterval: 120 * 1000,
        staleTime: 120 * 1000,
        queryFn: async ({pageParam}) => {
            const {data, error} = await getUserRetractPointHistory(100, pageParam)
            return data
        },
        getNextPageParam: (lastPage, allPages) => allPages.reduce((a, b) => a + b?.length || 0, 0),
    })

    const isEmpty = data?.pages?.at(0)?.length === 0
    const isReachingEnd = isEmpty || (data && data?.pages?.at(-1)?.length < PAGE_SIZE)

    return {data, refresh: refetch, isLoading, isFetchingNextPage, fetchNextPage, isReachingEnd}
}

export default useQueryPointRetractList
